var serializeForm = function (form) {
	var obj = {};
    console.log('form', document.querySelector(form))
	var formData = new FormData(document.querySelector(form));
    console.log('formData', formData)
	for (var key of formData.keys()) {
		obj[key] = formData.get(key);
	}
    console.log(new URLSearchParams(obj).toString())
    return new URLSearchParams(obj).toString()
};

var theoremCart =  {
    getCart: async function() {

        const response = await fetch(routes.shop_url+'/cart.js', {
            headers: {
                'Content-Type': 'application/json'
            }
        })

        const cart = await response.json()
        window.cart = cart
        document.dispatchEvent(new Event('cartUpdated'))
        return cart

        // EXAMPLE

        // theoremCart.getCart()
        // .then(data)
        // .catch((error) => console.error('Error:', error));
    },
    addItem: async function(productDetails) {
        const response = await fetch(routes.shop_url+'/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(productDetails)
        });
        const json = await response.json();
        return json;

        // EXAMPLE

        // theoremCart.addItem({
        //     'items': [{
        //         'id': variantId,
        //         'quantity': quantity,
        //         'properties': properties
        //     }]
        // })
        // .then(data => {
        //     if(!data.status) {
        //         // SUCCESS
        //         document.querySelectorAll('.j-qb-toggle').forEach(function(draw){ 
        //             draw.parentElement.parentElement.classList.remove('active');
        //         });
        //         document.dispatchEvent(new Event('cartUpdated'));
        //         console.log(data);
        //     } else {
        //         // ERROR
        //         alert(`${data.message}: ${data.description}`);    
        //     }
        // })
    },
    updateItem: async function(variantId, productQuantity) { 
        const items = {};
        items[variantId] = productQuantity;
        const response = await fetch(routes.shop_url+'/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({updates: items})
        });
        const json = await response.json();
        return json;
    },
    updateItems: async function(variantDetails) { 
        const response = await fetch(routes.shop_url+'/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({updates: variantDetails})
        });
        const json = await response.json();
        return json;

        // EXAMPLE

        // theoremCart.updateItems({
        //          variantId: quantity,
        //          794864053: 2,
        //          794864233: 3
        // })
    },
    addNote: async function(cartNote) { 
        const response = await fetch(routes.shop_url+'/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({note: cartNote})
        });
        const json = await response.json();
        return json;
    },
    addAttributes: async function(attributeObj) { 
        const response = await fetch(routes.shop_url+'/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: attributeObj
            })
        });
        const json = await response.json();
        return json;
    },
    changeItem: async function(lineItemDetails) {
        const response = await fetch(routes.shop_url+'/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(lineItemDetails)
            
        });
        const json = await response.json();
        return json;
    },
    clearItems: async function() {
        const response = await fetch(routes.shop_url+'/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }); 
        const json = await response.json();
        return json;
    },
    postShippingRates: async function(formSelector) {
        const response = await fetch(routes.shop_url+'/cart/prepare_shipping_rates.json?'+serializeForm(formSelector), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        const json = await response.json();
        setTimeout(() => {
            theoremCart.getShippingRates(formSelector)
        }, "1000");
    },
    getShippingRates: async function(formSelector) {
        const response = await fetch(routes.shop_url+'/cart/async_shipping_rates.json?'+serializeForm(formSelector), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        const json = await response.json();
        if (response != null) {
            return json;
        } else {
            setTimeout(() => {
                theoremCart.getShippingRates(formSelector)
            }, "1000");
        }
        
    }

};

window.theoremCart = window.theoremCart || theoremCart;

// let uniqueBundleId = 0;

const bundleManager = (function() {

    const getUniqueBundleId = function() {
        // replace with UUID
        
        return [...Array(30)].map(() => Math.random().toString(36)[2]).join('')

        //return uniqueBundleId++;

    }


    const addBundleToCart = function(items,cartRedirect=false) {

        console.log('addBundleToCart', items)

        bundleId = getUniqueBundleId()

        items = items.map(lineItem => {
            if(lineItem.properties._bundle_item == true) {
                lineItem.properties._bundle_uid = bundleId   
            }
            return lineItem
        })

        theoremCart.addItem({
            items
        })
        .then(response => {
            if(!response.status) {
                // SUCCESS
                if(cartRedirect){
                    window.location.pathname='/cart'
                }
                else{
                    theoremCart.getCart()
                }
                document.dispatchEvent(new Event('bundleAdded'))
                
            } else {
                // ERROR
                // document.dispatchEvent(new CustomEvent('bundleError', { 
                //     detail: {
                //         id: bundleId,
                //         data: [response]
                //     } 
                // }))
                console.log('undoing cart addition')
                
                updateBundleQuantity(bundleId, 0).then(() => {
                    document.dispatchEvent(new CustomEvent('bundleError', { 
                        detail: {
                            id: bundleId,
                            data: [response]
                        } 
                    }))
                })
                
            }
        })
            
    }


    // const undoCartAddition = async function(uniqueBundleId) {

    //     return await theoremCart.getCart()
    //         .then(response => {
    //             
    //         })

    // }

    const updateBundleQuantity = async function(bundleId, quantity) {

        console.log('Updating bundle ' + bundleId + ' quantity to ' + quantity)

        return await theoremCart.getCart()
            .then(response => {

                if(quantity == 0) {

                    const itemsToRemove = response
                        .items
                        .filter(item => item.properties?._bundle_uid == bundleId)
                        .reduce((accumulator, value) => { return { ...accumulator, [value.key]: 0 }}, {})

                    return theoremCart.updateItems(itemsToRemove)
                        .then(() => { console.log('All items removed'); return theoremCart.getCart() })

                } else {

                    const itemsToUpdate = response.items
                        .filter(item => item.properties?._bundle_uid == bundleId)

                    const originalQuantities = itemsToUpdate
                        .reduce((accumulator, value) => { return { ...accumulator, [value.key]: value.quantity }}, {})

                    const newQuantities = itemsToUpdate
                        .reduce((accumulator, value) => { return { ...accumulator, [value.key]: quantity }}, {})

                    return updateLineItemsQuantityRecursive(Object.entries(newQuantities))
                        .then(() => { console.log('All updates completed.'); return theoremCart.getCart() })
                        .catch((exception) => { console.log('Reverting stock to ', originalQuantities); theoremCart.updateItems(originalQuantities); throw exception }) 

                }
            })

    }

    const updateLineItemsQuantityRecursive = async function(lineItems) {

        const [id, quantity] = lineItems.pop()
        console.log('Updating ' + id + ' to quantity: ' + quantity)
        return await theoremCart.changeItem({ id, quantity })
            .then(response => {
                if(!response.status) {
                    if(lineItems.length == 0) {
                        return true
                    }
                    return updateLineItemsQuantityRecursive(lineItems)
                } else {
                    throw response.message
                }
            })
    }



    return {
        getUniqueBundleId,
        addBundleToCart,
        // undoCartAddition,
        updateBundleQuantity,
    }
})()


window.bundleManager = bundleManager

document.addEventListener('DOMContentLoaded', function(event) {

    document.addEventListener("click", function(event){ 

        if (!event.target.matches('[data-cart-add-bundle-async]')) return;

        event && event.preventDefault()

        const domElement = event.target
        const scope = domElement.closest('form')

        const items = scope.querySelector('[bundle]').value
        const addons = scope.querySelector('[addon]').value
        let parsedItems = JSON.parse(items)
        let addonItems = JSON.parse(addons)
        const bundleId = parsedItems[0].properties._bundle_sku

        parsedItems = [ ...parsedItems, ...addonItems ]
        // CartJS.addItems(JSON.parse(items));
        console.log('parsedItems', parsedItems)
        
        const cartRedirect = event.target.hasAttribute('data-redirect-to-cart');
        bundleManager.addBundleToCart(parsedItems,cartRedirect)

    })

});